export const decentDenTestnet = {
  id: 0x5752035,
  name: 'MST Testnet',
  // network: "mst-testnet",
  nativeCurrency: {
    name: 'tMST',
    symbol: 'tMST',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://testnetrpc.mstblockchain.com'],
      // http: ["http://103.119.171.254:5001/"]
    },
  },
  blockExplorers: {
    default: {
      name: 'MST Explorer',
      url: 'https://testnet.mstscan.com',
      apiUrl: 'https://testnet.mstscan.com',
    },
  },

  testnet: true,
};

export const ethereumMainnet = {
  id: 1, // ✅ Ethereum chainId
  name: 'Ethereum Mainnet',
  network: 'ethereum',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.ankr.com/eth', 'https://cloudflare-eth.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Etherscan',
      url: 'https://etherscan.io',
      apiUrl: 'https://api.etherscan.io',
    },
  },
  testnet: false,
};

export const currentNetwork = ethereumMainnet;
